import { IssueChallengeAction } from './issue-challenge';

export const success: IssueChallengeAction = async () => {
	return {
		id: 'mocked-challenge-id',
		challenge: 'mocked-challenge',
		difficulty: 1,
		timeout: 10000,
		maxRetries: 5,
	};
};


export const issueChallengeMocks = {
	success: success
};
